import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import hasProperty from "lodash/has";
import classNames from "classnames";
import { VERTICAL, HORIZONTAL } from "components/Forms/InputTypes";

function Radio({
  id,
  name,
  onChange,
  errors,
  errorKey,
  fieldValue = "",
  direction = HORIZONTAL,
  options = [],
  uuidSelectedOptions = [],
  defaultSelectedValues = [],
  formErrorClass = "form-error"
}) {
  const [formError, setFormError] = useState("");
  const [formErrorMessage, setFormErrorMessage] = useState("");

  useEffect(() => {
    setFormError("");
    setFormErrorMessage("");

    if (
      hasProperty(errors, "response.data.data.errors") &&
      errors.response.data.data.errors.length > 0
    ) {
      for (const iterator of errors.response.data.data.errors) {
        if (iterator.field === errorKey) {
          setFormError(formErrorClass || "form-error");
          setFormErrorMessage(iterator.message);
        }
      }
    }
  }, [name, errorKey, errors, formErrorClass]);

  const onInputChange = () => {
    setFormError("");
    setFormErrorMessage("");
  };

  return (
    <>
      <div
        className={classNames({
          "form-input-hgroup": direction === HORIZONTAL,
          "form-input-vgroup": direction === VERTICAL
        })}
      >
        {options.map((option, idx) => (
          <label key={idx} className="input-item">
            <input
              type="radio"
              className="form-input"
              value={option.value}
              id={id}
              name={name}
              checked={option.value === fieldValue}
              onChange={e => {
                onInputChange(e);
                onChange(e);
              }}
            />{" "}
            {option.value}
          </label>
        ))}
      </div>
      {formErrorMessage && <div className={formError}>{formErrorMessage}</div>}
    </>
  );
}

Radio.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  errorKey: PropTypes.string.isRequired, // The string that the api error returns in the "field" key
  classes: PropTypes.string,
  fieldValue: PropTypes.string,
  options: PropTypes.array,
  uuidSelectedOptions: PropTypes.array,
  formErrorClass: PropTypes.string
};

export default Radio;
